import React from "react";
import SearchableCombobox from "@/components/SearchableCombobox";

/**
 * Searchable picker for recipes — used by BatchCalculator, Production Run
 * creation dialog, etc.
 *
 * Secondary line shows `code · category · N ingredients`. Search covers name,
 * code and description.
 */
export default function RecipeCombobox({
  recipes = [],
  value = "",
  onPick,
  testId = "recipe-combobox",
  placeholder = "Search recipe…",
  className = "",
  disabled = false,
}) {
  return (
    <SearchableCombobox
      options={recipes}
      value={value}
      onPick={onPick}
      testId={testId}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      emptyLabel="No matching recipes."
      getId={(r) => r.id}
      getKey={(r) =>
        String(r.code || `name:${(r.name || "").toLowerCase()}`).trim()
      }
      getLabel={(r) => r.name || r.code || ""}
      getSecondary={(r) => {
        const parts = [r.code || "—"];
        if (r.category) parts.push(r.category);
        const n = (r.items || []).length;
        parts.push(`${n} ingredient${n === 1 ? "" : "s"}`);
        return parts.join(" · ");
      }}
      getSearchFields={(r) => [r.name, r.code, r.description]}
    />
  );
}
